import React from "react";
import { Chart } from "react-google-charts";
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

import Decrease from './../images/decrease.svg';
import Increase from './../images/increase.svg';

const styles = {
  dial: {
    width: `auto`,
    height: `auto`,
    color: "#000",
    border: "0.5px solid #fff",
    padding: "2px"
  },
  title: {
    fontSize: "1em",
    color: "#000"
  }
};

function Disabled({ disabled, children }) {
  if (disabled) {
    return (
      <div style={{ opacity: 0.3, pointerEvents: "none" }} disabled>
        {children}
      </div>
    );
  }
  return <React.Fragment>{children}</React.Fragment>;
}

const Level = ({ id, value, title, desc, status, trend, value_kg, disabled }) => {
  return (
    <Disabled disabled={disabled}>
    <Stack direction="column" align="left">
      <div style={styles.dial}>
        <Chart
          height={160}
          chartType="Gauge"
          loader={<div></div>}
          data={[
            ["Label", "Value"],
            [status, Number(value)]
          ]}
          options={{
            redFrom: 70,
            redTo: 100,
            yellowFrom: 50,
            yellowTo: 70,
            minorTicks: 5,
            min: 0,
            max: 100
          }}
        />
      </div>
      <Typography variant="caption" gutterBottom component="div">
        {desc}
      </Typography>
      <Stack direction="row" spacing={1}>
      <Typography variant="subtitle1" gutterBottom component="div">
        {value}% ({value_kg.toLocaleString()} kg)
      </Typography>{(parseFloat(trend) > 0) ? <img
              src={Increase}
              loading="lazy"
              style={
                {
                  width: 20,
                  height: 20,
                }
              }
            /> : <img
            src={Decrease}
            loading="lazy"
            style={
              {
                width: 20,
                height: 20,
              }
            }
          />}
          </Stack>
      </Stack>
      </Disabled>
  );
};

export default Level;
